import behaviors from './assets/behaviors';
/* **************************************************************
  TOOLTIP TEXT
*************************************************************** */

export const TOOLTIPS = {
  superstar: 'People who have over 500 000 followers',
  macro: 'People who have between 10 000 and 500 000 followers',
  micro: 'People who have between 1 000 and 10 000 followers',
  voice: 'People who have less than 1 000 followers',

  posts: 'Number of posts detected with the product in the image on the selected period',
  reach:
    'Sum of followers of all the detected posts, representing all the people who could have seen the posts',
  engagement: 'Number of people who engaged with the posts, by liking or commenting',

  commercial:
    'Number of posts with selling purpose whether it is re-sellers, second hand or counterfeits',
  noncommercial: 'Number of posts with no commercial purpose',
  owned: 'Number of posts from your brand’s official account(s).',
};

/* **************************************************************
  BEHAVIORS
*************************************************************** */

export const BEHAVIORS = {
  star: {
    color: '#00D184',
    display: 'Star',
    description: 'Growing at a fast pace',
    img: behaviors.risingStarWhite,
  },
  seasonal_riser: {
    color: '#00DEF0',
    display: 'Seasonal riser',
    description: 'Growing at a slow pace and seasonal',
    img: behaviors.seasonalRiserWhite,
  },
  sustained_riser: {
    color: '#007DCB',
    display: 'Sustained riser',
    description: 'Growing at a slow pace',
    img: behaviors.sustainedRiserWhite,
  },
  falling_star: {
    color: '#FF3B00',
    display: 'Falling star',
    description: 'Declining at a fast pace',
    img: behaviors.fallingStarWhite,
  },
  seasonal_decliner: {
    color: '#F27D27',
    display: 'Seasonal decliner',
    description: 'Declining at a slow pace and seasonal',
    img: behaviors.seasonalDeclinerWhite,
  },
  sustained_decliner: {
    color: '#F7C700',
    display: 'Sustained decliner',
    description: 'Declining at a slow pace',
    img: behaviors.sustainedDeclinerWhite,
  },
  flat: {
    color: '#8D8D8D',
    display: 'Flat',
    description: 'Remaining stable',
    img: behaviors.flatWhite,
  },
  seasonal_flat: {
    color: '#8D8D8D',
    display: 'Seasonal flat',
    description: 'Remaining stable and seasonal',
    img: behaviors.seasonalFlatWhite,
  },
};

export const BEHAVIORS_GREY = {
  star: {
    color: '#00D184',
    display: 'Star',
    description: 'Growing at a fast pace',
    img: behaviors.risingStarGrey,
  },
  seasonal_riser: {
    color: '#00DEF0',
    display: 'Seasonal riser',
    description: 'Growing at a slow pace and seasonal',
    img: behaviors.seasonalRiserGrey,
  },
  sustained_riser: {
    color: '#007DCB',
    display: 'Sustained riser',
    description: 'Growing at a slow pace',
    img: behaviors.sustainedRiserGrey,
  },
  falling_star: {
    color: '#FF3B00',
    display: 'Falling star',
    description: 'Declining at a fast pace',
    img: behaviors.fallingStarGrey,
  },
  seasonal_decliner: {
    color: '#F27D27',
    display: 'Seasonal decliner',
    description: 'Declining at a slow pace and seasonal',
    img: behaviors.seasonalDeclinerGrey,
  },
  sustained_decliner: {
    color: '#F7C700',
    display: 'Sustained decliner',
    description: 'Declining at a slow pace',
    img: behaviors.sustainedDeclinerGrey,
  },
  flat: {
    color: '#8D8D8D',
    display: 'Flat',
    description: 'Remaining stable',
    img: behaviors.flatGrey,
  },
  seasonal_flat: {
    color: '#8D8D8D',
    display: 'Seasonal flat',
    description: 'Remaining stable and seasonal',
    img: behaviors.seasonalFlatGrey,
  },
};

/* **************************************************************
  CHARTS
*************************************************************** */

export const CHARTSCOLORS = ['#96BFFA', '#F4ECA8', '#9C81DB', '#AFB18D'];

export const SEASONS = ['Spring', 'Summer', 'Fall', 'Winter'];
export const SEASONS_AS_MONTHS = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [10, 11, 12]];
